export default "__VITE_ASSET__b6jct30w__"